import { render, staticRenderFns } from "./systemGlobal.vue?vue&type=template&id=7f9aa820&scoped=true"
import script from "./systemGlobal.vue?vue&type=script&lang=js"
export * from "./systemGlobal.vue?vue&type=script&lang=js"
import style0 from "./systemGlobal.vue?vue&type=style&index=0&id=7f9aa820&prod&scoped=true&lang=css"
import style1 from "./systemGlobal.vue?vue&type=style&index=1&id=7f9aa820&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9aa820",
  null
  
)

export default component.exports